/**Search Constants */
/** Search sections */
export enum SearchSections {
  YOUR_SUGGESTIONS = "yourSuggestions",
  TRENDING_SUGGESTIONS = "trendingSuggestions",
  BEAUTY_SEARCHES = "beautySearches",
}
/** local storage variable */
export const YOUR_SEARCH_ITEMS = "YOUR_SEARCH_ITEMS";
/** Count of items to show for your search items */
export const YOUR_SEARCH_ITEMS_DISPLAY_LIMIT = 5;
/** Count of items to show for top search items */
export const TRENDING_SEARCH_ITEMS_DISPLAY_LIMIT = 5;
/** Char count for search */
export const SEARCH_CHAR_COUNT = 3;

export const TRENDING_SEARCHES = [
  {
    suggestion: "Dyson",
  },
  {
    suggestion: "Lancome",
  },
  {
    suggestion: "CeraVe",
  },
  {
    suggestion: "Clarins",
  },
  {
    suggestion: "Biotherm",
  },
];

export const SEARCH_COPY_MAP = {
  en: {
    SEARCH: "Search",
    SUBMIT: "Submit Search",
    CLEAR: "Clear Search",
    RECENT: "Recent Searches",
    TRENDING: "Trending Searches",
    EMPTY_MESSAGE: "No results found",
  },
  fr: {
    SEARCH: "Recherche",
    SUBMIT: "Soumettre la recherche",
    CLEAR: "Effacer la recherche",
    RECENT: "recherches récentes",
    TRENDING: "recherches tendances",
    EMPTY_MESSAGE: "Aucun résultat trouvé",
  },
};
